module.exports = __webpack_public_path__ + "static/img/5.7bf61f0.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_left_icon/5.png
// module id = 8s1z
// module chunks = 1